import { prop } from 'ramda';

export const nationalitiesSelector = prop('nationalities');


// WEBPACK FOOTER //
// ./src/selectors/nationalitySelectors.js